import { update, init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../Bfs.Web.Portale/Types.fs.js";
import { ofArray, tail, head, isEmpty } from "../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { WebPart$3 } from "../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(init, update, view, (model_1) => {
    let matchValue, mandatData, mandatData_1, mandatData_2;
    return new PageHeader(1, [(matchValue = model_1.OpenMandat, (matchValue != null) ? ((matchValue.tag === 3) ? ((mandatData = matchValue.fields[0], `SEPA-Lastschriftmandat erteilen (${mandatData.Rechnungsempfaenger})`)) : ((matchValue.tag === 2) ? ((mandatData_1 = matchValue.fields[0], `SEPA-Lastschriftmandat erteilen (${mandatData_1.Rechnungsempfaenger})`)) : ((matchValue.tag === 1) ? ((mandatData_2 = matchValue.fields[0], `SEPA-Lastschriftmandat (${mandatData_2.Rechnungsempfaenger})`)) : "SEPA-Lastschriftmandat erteilen"))) : "SEPA-Lastschriftmandat erteilen")]);
}, (_arg_2) => (!isEmpty(_arg_2) ? ((head(_arg_2) === "sepa") ? (!isEmpty(tail(_arg_2)) ? (isEmpty(tail(tail(_arg_2))) ? (new Page(head(tail(_arg_2)))) : undefined) : undefined) : undefined) : undefined), (_arg_1) => ofArray(["sepa", _arg_1.fields[0]]), (_arg) => {
    if (_arg.tag === 2) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
